import { render, staticRenderFns } from "./palletConfiguration.vue?vue&type=template&id=fd0777fe&"
import script from "./palletConfiguration.vue?vue&type=script&lang=js&"
export * from "./palletConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd0777fe')) {
      api.createRecord('fd0777fe', component.options)
    } else {
      api.reload('fd0777fe', component.options)
    }
    module.hot.accept("./palletConfiguration.vue?vue&type=template&id=fd0777fe&", function () {
      api.rerender('fd0777fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/palletConfiguration.vue"
export default component.exports